import { normTable, tableColumns2 } from "../data/NormManage";
import { post } from "../utils/request";
import { getNormTypeName } from "../utils/utilApi";
// import { Queue } from "../utils/queue";

export default {
  data() {
    return {
      activeName: "first",
      showableComp: {
        showAddModel: false,
        showImportModel: false
      },
      selectNormType: "",
      departmentId: JSON.parse(sessionStorage.getItem("departmentInfo")).departmentId,
      normTable: [],
      normItems: [],
      tableColumns2: [],
      selectOptions: [
        { value: 0, label: "全部" },
        { value: 1, label: "按年" },
        { value: 2, label: "按季" },
        { value: 3, label: "按月" },
      ],
      normTypeArr: [
        { value: 1, label: "共性指标" },
        { value: 3, label: "关键指标" },
        { value: 4, label: "加减分" },
        { value: 5, label: "民主测评" },
        { value: 6, label: "服务对象评价" },
      ],
      selectOption: "",
      showAddModel: false,
      showImportModel: false,
      // 新增指标表单
      addNormForm: {
        normId: "",
        normName: "",
        normType: "",
        parentNormName: "",
        parentId: "",
        normScore: "",
        normDetail: "",
        evaCriterion: "",
        level: "",
      },
      parentNormList: [],
      defaultProps: {
        children: "children",
        label: "normName",
        value: "normId",
      },
      // 更新指标后新增指标模态框中的上级指标数据也要更新
      searchFlag: true,
    };
  },
  name: "NormManage",
  components: {},
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleNodeClick(data) {
      this.addNormForm.parentId = data.normId;
      this.addNormForm.parentNormName = data.normName;
      this.addNormForm.level = data.level + 1;
      this.$refs.selectTree.blur();
    },
    clearHandle() {
      this.addNormForm.normId = "";
      this.addNormForm.normName = "";
    },
    formatter(row, column) {
      if (column.property == "normType") {
        return getNormTypeName(row.normType);
      } else {
        return row[column.property];
      }
    },
    // 编辑指标
    handleEdit(index, row) {
      this.searchParentNorm();
      this.addNormForm = this.$options.data().addNormForm;
      this.addNormForm = row;
      this.showableComp.showAddModel = true;
    },
    // 添加指标
    handleAdd() {
      this.searchParentNorm();
      this.addNormForm = this.$options.data().addNormForm;
      this.showableComp.showAddModel = true;
    },
    selectMenu(index) {
      this.selectNormType = index;
    },
    onCancel() {
      this.showableComp.showAddModel = false;
    },
    /**
     * @description 查询一个局内的指标并转换为树结构(该功能只有局级管理使用)
     * @function POST /norm/search/batch
     * 
     * @param normType int 指标类型(1共性指标3关键指标4加减分5民主测评6服务对象测评)
     * @param departmentId int 局ID
     * @param type int 查找方式。type=1时，按normType和departmentId进行查找并转化树形结构再返回（normType可能为空）；type=2时，只要查找level<=2的指标
     * 
     * @returns normItems[], json对象的名称为normItems
     * @returns normItems中的每一项属性都要如md文件中的样例所示
     */
    searchNorm() {
      let data = {
        normType: this.selectNormType,
        departmentId: this.departmentId,
        type: 1,
      }
      post('/norm/search/batch', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          console.log(JSON.parse(res.data.normItems));
          this.normItems = JSON.parse(res.data.normItems);
        }
        if (res.code == 204) {
          this.normItems = [];
        }
      });
    },
    searchParentNorm() {
      console.log("查询上级指标", this.searchFlag == true);
      if (this.searchFlag == true) {
        let data = {
          normType: this.addNormForm.normType,
          departmentId: this.departmentId,
          type: 2,
        }
        console.log("准备post");
        post('/norm/search/batch', JSON.stringify(data)).then(res => {
          if (res.code == 200) {
            this.parentNormList = JSON.parse(res.data.normItems);
          }
          if (this.parentNormList != null && this.parentNormList.length > 0) {
            this.searchFlag = false;
          }
        });
      }
    },
    /**
     * @description 添加指标
     * @function POST /norm/add
     * 
     * @param normName string 指标名称
     * @param normType int 指标类型(1共性,2个性,3关键,4加减分,5民主测评,6服务对象测评)
     * @param parentId int 上级指标Id
     * @param normScore int 标准分值
     * @param normDetail string 指标内容
     * @param evaCriterion string 评价标准
     * @param departmentId int 部门ID
     * @param level int 指标等级
     * 
     * 
     * @returns normId 指标ID
     */
    addNorm() {
      this.addNormForm.departmentId = this.departmentId;
      post('/norm/add', JSON.stringify(this.addNormForm)).then(res => {
        if (res.code == 200) {
          // 后续调整
          this.addNormForm.normId = JSON.parse(res.data.normId);
        }
        this.showableComp.showAddModel = false;
        this.searchFlag = true;
        // 遍历normItems后push进去
        this.searchNorm();
      });
    },
    /**
     * @description 保存指标
     * @function POST /norm/save
     * 
     * @param normId int 指标ID
     * @param normName string 指标名称
     * @param normType int 指标类型(1共性,2个性,3关键,4加减分,5民主测评,6服务对象测评)
     * @param parentId int 上级指标Id
     * @param normScore int 标准分值
     * @param normDetail string 指标内容
     * @param evaCriterion string 评价标准
     * @param departmentId int 部门ID
     * @param level int 指标等级
     * 
     * 
     * @returns normId 指标ID
     */
    saveNorm() {
      this.addNormForm.departmentId = this.departmentId;
      post('/norm/save', JSON.stringify(this.addNormForm)).then(res => {
        if (res.code == 200) {
          // 后续调整
        }
        this.showableComp.showAddModel = false;
        this.searchFlag = true;
        // 遍历normItems后push进去
        this.searchNorm();
      });
    },
    /**
     * @description 删除指标
     * @function POST /norm/delete
     * 
     * @param normId int 指标ID
     */
    deleteNormItem(index, row) {
      let data = {
        normId: row.normId,
      }
      post('/norm/delete', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          // 遍历list删除指标
          this.searchNorm();
          this.searchFlag = true;
        }
      });
    },
    // 点击确定按钮做提交
    doSubmit() {
      if (this.addNormForm.normId == "") {
        // 新增
        this.addNorm();
      } else {
        // 保存
        this.saveNorm();
      }
    }
  },
  watch: {
    selectNormType() {
      this.searchNorm();
    },
  },
  created() {
    this.normTable = normTable;
    this.tableColumns2 = tableColumns2;
  },
};